import api from './api';

export const dotTuyenDungService = {

  getAll: () => api.get('/dot-tuyen-dung'),


  getById: (id) => api.get(`/dot-tuyen-dung/${id}`),
};

export default dotTuyenDungService;
